import type { ColumnConfig } from '@/components/configure-columns-dialog';

// Default column configuration for the Additions Transaction History screen
export const DEFAULT_ADDITIONS_COLUMNS: ColumnConfig[] = [
  // Default columns (visible by default)
  { id: 'reference', label: 'Reference', visible: true, order: 0, group: 'default' },
  { id: 'date', label: 'Date', visible: true, order: 1, group: 'default' },
  { id: 'period', label: 'Period', visible: true, order: 2, group: 'default' },
  { id: 'year', label: 'Year', visible: true, order: 3, group: 'default' },
  { id: 'periodType', label: 'Period Type', visible: true, order: 4, group: 'default' },
  { id: 'totalValue', label: 'Total Value', visible: true, order: 5, group: 'default' },
  { id: 'postedBy', label: 'Posted By', visible: true, order: 6, group: 'default' },
  { id: 'postedDate', label: 'Posted Date', visible: true, order: 7, group: 'default' },
  { id: 'status', label: 'Status', visible: true, order: 8, group: 'default' },
  
  // Optional columns (hidden by default)
  { id: 'preparedBy', label: 'Prepared By', visible: false, order: 9, group: 'optional' },
  { id: 'preparedDate', label: 'Prepared Date', visible: false, order: 10, group: 'optional' },
  { id: 'notes', label: 'Notes', visible: false, order: 11, group: 'optional' },
  { id: 'itemCount', label: 'Item Count', visible: false, order: 12, group: 'optional' },
];

export const ADDITIONS_COLUMNS_STORAGE_KEY = 'additions-columns-config';
